import React from 'react'
import Breadcrumbs from '../Breadcrumbs'
import '../../css/desembarqueCarga.scss'
import Footer from '../Footer'

export default function DesembarqueCarga() {
  return (
    <>
      <section className='desembarque-carga'>

        {/* HERO */}
        <div className='desembarque-carga-hero'>

            <div className='overlay'></div>

            <div className='container hero-content'>

                <div style={{ marginTop: '4rem' }}>
                    <Breadcrumbs />
                </div>

                <h1>Desembarque con unidades de carga</h1>
                
              <p>
                Conozca el proceso logístico para el desembarque tu unidad de carga.
              </p>


            </div>

        </div>


        {/* INSTRUCCIONES */}
        <div className='container'>

          <div className='desembarque-carga-grid'>

            {/* CARD */}
            <div className='desembarque-carga-card'>

              <div className='desembarque-carga-icon'>
                <i className="fi fi-rs-boxes"></i>
              </div>

              <h3>Organización por Cubiertas</h3>

              <p>
                El orden de salida depende estrictamente de la cubierta
                asignada durante el embarque. La letra correspondiente
                aparece claramente en el boleto del operador.
              </p>

              <div className='desembarque-carga-card-footer'>
                <i className="fi fi-rs-info"></i>
                <span>Verifique su boleto impreso</span>
              </div>

            </div>

            {/* CARD */}
            <div className='desembarque-carga-card'>

              <div className='desembarque-carga-icon'>
                <i className="fi fi-rs-megaphone"></i>
              </div>

              <h3>Aviso por Altavoces</h3>

              <p>
                Minutos antes de arribar a puerto, el personal indicará
                mediante altavoces qué cubiertas deben prepararse para
                el desembarque inmediato.
              </p>

              <div className='desembarque-carga-card-footer'>
                <i class="fi fi-rs-clock"></i>
                <span>Atención al arribo</span>
              </div>

            </div>

            {/* CARD */}
            <div className='desembarque-carga-card'>

              <div className='desembarque-carga-icon'>
                <i className="fi fi-rs-shield-check"></i>
              </div>

              <h3>Protocolo Externo</h3>

              <p>
                Al bajar del buque, es obligatorio seguir las señales
                de salida y las revisiones realizadas por autoridades
                portuarias externas.
              </p>

              <div className='desembarque-carga-card-footer'>
                <i className="fi fi-rs-scale"></i>
                <span>Normativa oficial</span>
              </div>

            </div>

          </div>

        </div>

        {/* PROCESO */}
        <div className='desembarque-carga-proceso'>

          <div className='container'>

            <div className='desembarque-carga-proceso-content'>

              {/* IZQUIERDA */}
              <div className='desembarque-carga-timeline'>

                <h2>Proceso de Salida y Revisiones</h2>

                <p className='desembarque-carga-intro'>
                  Una vez abajo del buque, deberá seguir las indicaciones
                  para salir del puerto y completar las revisiones externas.
                </p>

                <div className='desembarque-carga-steps'>

                  <div className='timeline-item'>
                    <div className='timeline-dot'></div>

                    <div>
                      <h4>Indicaciones de seguridad</h4>
                      <p>Sigue las indicaciones del personal de seguridad.</p>
                    </div>
                  </div>

                  <div className='timeline-item'>
                    <div className='timeline-dot'></div>

                    <div>
                      <h4>Toma tu vehículo</h4>
                      <p>Dirígete a tu unidad de manera ordenada.</p>
                    </div>
                  </div>

                  <div className='timeline-item'>
                    <div className='timeline-dot'></div>

                    <div>
                      <h4>Revisión de Marina</h4>
                      <p>Pasa por la inspección de autoridades navales.</p>
                    </div>
                  </div>

                  <div className='timeline-item'>
                    <div className='timeline-dot'></div>

                    <div>
                      <h4>Pago ATP + Fumigación</h4>
                      <p>Liquidación de impuestos portuarios correspondientes.</p>
                    </div>
                  </div>

                  <div className='timeline-item'>
                    <div className='timeline-dot'></div>

                    <div>
                      <h4>Revisión militar</h4>
                      <p>Control de seguridad por parte del personal militar.</p>
                    </div>
                  </div>

                  <div className='timeline-item'>
                    <div className='timeline-dot'></div>

                    <div>
                      <h4>Fumigación final</h4>
                      <p>Último paso del protocolo sanitario portuario.</p>
                    </div>
                  </div>

                </div>

              </div>

              {/* DERECHA */}
              <div className='desembarque-carga-sidebar'>

                {/* TIEMPO */}
                <div className='desembarque-carga-tiempo'>

                  <div className='desembarque-carga-tiempo-top'>
                    <i class="fi fi-rs-clock"></i>

                    <h3>Tiempo Estimado</h3>
                  </div>

                  <p>
                    El tiempo de desembarque de las unidades puede variar
                    de 30 minutos a 1 hora.
                  </p>

                  <span>
                    Dependiendo del acomodo dentro del buque y flujo operativo.
                  </span>

                </div>

                {/* CARGOS */}
                <div className='desembarque-carga-cargos'>

                  <div className='desembarque-carga-cargos-title'>
                    <i className="fi fi-rs-money"></i>

                    <h3>Cargos Portuarios</h3>
                  </div>

                  <p>
                    El puerto cobra <strong>$350 MXN</strong> por ATP
                    (uso de instalaciones portuarias) y
                    <strong> $35 MXN</strong> por fumigación y control
                    sanitario de mercancía rodada.
                  </p>

                </div>

              </div>

            </div>

          </div>

        </div>

        
        {/* SOPORTE */}
        <section className='desembarque-support'>

            <div className='container'>

            <div className='desembarque-support-content'>

                <h2>¿Necesita asistencia adicional?</h2>

                <p>
                Nuestro equipo está disponible en todo momento para ayudarle
                con su equipaje o cualquier requerimiento especial durante
                el desembarque.
                </p>

                <div className='desembarque-support-buttons'>

                <a href='https://www.bajaferries.com.mx/preguntas-frecuentes' target='_blank' rel="noreferrer" className='durante-link'>
                    Preguntas Frecuentes <i class="fi fi-rr-arrow-up-right-from-square"></i>
                  </a>

                </div>

            </div>

            </div>

        </section>

        <Footer />
      </section>
    </>
  )
}